// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 945 ? "dashboard" : chunkId) + "." + {"185":"2b956810","218":"e19056a7","389":"40e9858e","671":"dbcab6cd","858":"9eb7c526","889":"5c9e6b91","945":"e5d568ed","970":"3872f5d5"}[chunkId] + ".css";
};